import BibliaOnline from "./biblia-online";

class Espiritualidade {
	constructor() {
		new BibliaOnline();
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('#espiritualidade-content');

	if (container) {
		new Espiritualidade();
	}
})
